export default __webpack_public_path__ + "static/svg-sprite-db0c43f6c621310bbf6b85646c6f7dfd.svg";